import {IEnvironment} from '../app/application/constants'

export const environment: IEnvironment = {
  production: false,
  apiUrl: 'https://api-resource-booking-be-test.framfab.net/api',
  bankIdGatewayUrl: 'https://api-ff-bankid-gw-test.framfab.net/service',
  audience: 'app.framfab.net'
}